import { defineStore } from 'pinia'
import { computed } from 'vue'
import CountersService from '@/services/httpTypescript/api/counters'
import type { Maybe, Counters } from '@/types'

export const useCountersStore = defineStore('counters', () => {
  const { parsedData: counters, execute: fetchCounters } = CountersService.getCounters()

  const getCounters = computed<Maybe<Counters>>(() => counters.value?.data)

  return {
    counters,
    getCounters,
    fetchCounters
  }
})
